import React, { Component } from 'react';

import './styles.less';

class UndoButton extends Component {
  render() {
    const { currentTrimRange, undoStack } = this.props;

    const canUndo = currentTrimRange == null && undoStack.length > 0;

    const undoOnClick = canUndo ? this.props.onUndoTrim : null;
    const undoClass = canUndo ? 'enabled' : '';

    return (
      <div
        className={`trim-bar-button trim-bar-undo-button ${undoClass}`}
        onClick={undoOnClick}
      >
        <span className="icon" />
        <span className="label">Undo</span>
      </div>
    );
  }
}

export default UndoButton;
